import { create } from "zustand";
import { persist } from "zustand/middleware";
import { createPartnerSlice, PartnerSlice } from "./slices/partner-slice";
import {
  createAuthorizationSlice,
  AuthorizationSlice,
} from "@/stores/slices/authorization-slice.ts";
import { CartSlice, createCartSlice } from "@/stores/slices/cart-slice.ts";
import {
  CartDeliveryAddressSlice,
  createCartDeliveryAddressSlice,
} from "./slices/cart-delivery-address.slice";
import { useGridStateStore } from "./grid-state-store";

interface StoreState
  extends PartnerSlice,
    AuthorizationSlice,
    CartSlice,
    CartDeliveryAddressSlice {
  resetStore: () => void;
}

export const useGlobalStore = create<StoreState>()(
  persist(
    (...a) => ({
      ...createPartnerSlice(...a),
      ...createAuthorizationSlice(...a),
      ...createCartSlice(...a),
      ...createCartDeliveryAddressSlice(...a),
      resetStore: () => {
        a[1]().resetPartner();
        a[1]().resetAuthorization();
        a[1]().resetCart();
        a[1]().resetCartDeliveryAddress();
        useGridStateStore.getState().clearAll();
      },
    }),
    {
      name: "global-store",
    }
  )
);
